// extracted by mini-css-extract-plugin
export default {"spinner":"Style_spinner__aEwYQ","spin":"Style_spin__b+NW4"};